import React from 'react';
import { Helmet } from 'react-helmet-async';
export const SchemaMarkup = () => {
  // Article/ReviewArticle Schema
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'ReviewArticle',
    headline: 'Endocrinologist Review: A Look at the Advanced Mineral Drops from Nivie Organics',
    datePublished: '2025-09-26',
    dateModified: '2025-09-26',
    image: 'https://images.unsplash.com/photo-1581056771107-24247a7b6087',
    author: {
      '@type': 'Person',
      name: 'Dr. Elena Vasquez',
      jobTitle: 'Endocrinologist',
      description: 'Practicing endocrinologist with over 15 years of experience'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Top Health Insider',
      logo: {
        '@type': 'ImageObject',
        url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b3PGU9GV81h1ZaHnnndvQZ/ddEpruXNUzZl9zX8arGEd.png'
      }
    },
    description: 'An evidence-based analysis of Nivie Organics mineral supplements formulation and its potential benefits for thyroid health',
    articleBody: 'As an endocrinologist with over 15 years of experience, I regularly treat thyroid disorders, hormonal imbalances, and the persistent fatigue caused by mineral deficiencies...',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: '4.5',
      bestRating: '5',
      worstRating: '1'
    },
    itemReviewed: {
      '@type': 'Product',
      name: 'Nivie Organics Mineral Drops',
      description: 'Advanced mineral supplement formulation for thyroid health and energy support',
      brand: {
        '@type': 'Brand',
        name: 'Nivie Organics'
      },
      offers: {
        '@type': 'Offer',
        url: 'https://nivieorganics.com/pages/mineral-drops',
        availability: 'https://schema.org/InStock'
      }
    },
    keywords: 'Nivie Organics reviews, is Nivie Organics legit, Nivie drops, thyroid supplement review, mineral supplements for energy'
  };
  // FAQ Schema
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Is Nivie Organics a legitimate company?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Nivie Organics is a legitimate supplement company that produces mineral drops and other health products. Their formulations are based on scientific research and contain bioavailable forms of minerals and vitamins. Their products are manufactured in facilities that follow good manufacturing practices.'
      }
    }, {
      '@type': 'Question',
      name: 'Are Nivie Organics Mineral Drops effective?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'According to our review by Dr. Elena Vasquez, an endocrinologist with 15+ years of experience, Nivie Organics Mineral Drops contain scientifically-backed ingredients in bioavailable forms that may help support thyroid function and overall energy levels. Individual results may vary, and the product should be used as part of a comprehensive approach to health.'
      }
    }, {
      '@type': 'Question',
      name: 'What ingredients are in Nivie Organics Mineral Drops?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Nivie Organics Mineral Drops contain 13 key ingredients including Beta-Carotene, Lutein, Zeaxanthin, Lycopene, Astaxanthin, Vitamin C, Vitamin E, Vitamin B6, Vitamin B12, Zinc, Copper, and Magnesium in a base of vegetable glycerin, purified water, organic ethanol, citric acid, potassium sorbate, and natural flavors.'
      }
    }, {
      '@type': 'Question',
      name: 'Do medical professionals recommend Nivie Organics?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Some medical professionals do recommend Nivie Organics products for specific health concerns. In our review, Dr. Elena Vasquez, an endocrinologist, found the formula to be well-formulated and science-aligned for mineral support. As with any supplement, it's important to consult with your healthcare provider before starting."
      }
    }]
  };
  // WebPage Schema
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Is Nivie Organics Legit? Endocrinologist Reviews Nivie Drops',
    description: 'A thorough, evidence-based review of Nivie Organics Mineral Drops by an experienced endocrinologist. Find out if these supplements are legitimate and effective.',
    keywords: ['nivie organics reviews', 'is nivie organics legit', 'nivie drops review', 'nivie organics mineral drops', 'thyroid supplement review'],
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['h1', 'h2', '.speakable']
    }
  };
  // Meta title and description for SEO
  const pageTitle = 'Is Nivie Organics Legit? Endocrinologist Reviews Mineral Drops | Top Health Insider';
  const pageDescription = 'An evidence-based analysis of Nivie Organics Mineral Drops by Dr. Elena Vasquez, MD. Discover if these supplements actually work for thyroid health and energy.';
  // Featured image for social sharing
  const featuredImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/hssL3J5h8oCVqzsxkASQUA/Scientist_examining_mineral_samples_in_laboratory.jpg';
  return <Helmet data-id="element-3793">
      {/* Basic Meta Tags */}
      <title data-id="element-3794">{pageTitle}</title>
      <meta name="description" content={pageDescription} data-id="element-3795" />
      <meta name="keywords" content="nivie organics reviews, is nivie organics legit, mineral drops review, thyroid supplement, endocrinologist review" data-id="element-3796" />
      {/* Canonical URL */}
      <link rel="canonical" href="https://tophealthinsider.com/is-nivie-organics-drops-legit" data-id="element-3797" />
      {/* Open Graph Meta Tags for Facebook, LinkedIn, etc. */}
      <meta property="og:type" content="article" data-id="element-3798" />
      <meta property="og:title" content={pageTitle} data-id="element-3799" />
      <meta property="og:description" content={pageDescription} data-id="element-3800" />
      <meta property="og:image" content={featuredImage} data-id="element-3801" />
      <meta property="og:url" content="https://tophealthinsider.com/is-nivie-organics-drops-legit" data-id="element-3802" />
      <meta property="og:site_name" content="Top Health Insider" data-id="element-3803" />
      <meta property="article:published_time" content="2025-09-26T08:00:00+00:00" data-id="element-3804" />
      <meta property="article:author" content="Dr. Elena Vasquez, MD" data-id="element-3805" />
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-3806" />
      <meta name="twitter:title" content={pageTitle} data-id="element-3807" />
      <meta name="twitter:description" content={pageDescription} data-id="element-3808" />
      <meta name="twitter:image" content={featuredImage} data-id="element-3809" />
      {/* Schema.org JSON-LD Structured Data */}
      <script type="application/ld+json" data-id="element-3810">
        {JSON.stringify(articleSchema)}
      </script>
      <script type="application/ld+json" data-id="element-3811">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json" data-id="element-3812">
        {JSON.stringify(webPageSchema)}
      </script>
    </Helmet>;
};